import { ICreateSendCrmState } from '../types/createSendCrm';

export const DEFAULT_CREATE_SEND_CRM_STATE: ICreateSendCrmState = {
  byRecipientUid: {},
  pending: null,
  shipment: null,
};

export const CRM_RECORD_REQUIRED_MESSAGE = 'Select a CRM contact to continue';
